module.exports = __webpack_public_path__ + "f1bcbbad46fb60569c17f3a4df7a28e2.pdf";